import React, { useState, useEffect } from 'react';
import { ProductBundleItem } from './ProductBundleItem';
import SubscriptionTab from './SubscriptionTab';
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import DOMPurify from 'dompurify';
import { clsx } from "clsx"


export const addIconsToListItems = (html, usp_bullet_icon) => {
  const div = document.createElement('div');
  div.innerHTML = DOMPurify.sanitize(html);
  
  const listItems = div.querySelectorAll('li');
  listItems.forEach(li => {
    const iconSpan = document.createElement('span');
    iconSpan.className = `icon-${usp_bullet_icon}`;
    iconSpan.style.marginRight = '8px';
    li.prepend(iconSpan);
  });

  
  const strongElements = div.querySelectorAll('strong');
  strongElements.forEach(strong => {
    strong.classList.add('b4--bold');
  });
  
  
  return div.innerHTML;
};

export const ProductSellingGroups = ({
  product,
  bundle,
  showAddToCart = false,
  translations,
  showHeader = false,
  layout = 'tabs', // "inline" or "tabs"
  isInTile = false,
  settings
}) => {
  const productPrice = product?.price / 100;
  const limit = isInTile ? 1 : 10;

  let firstVariant: any = null;
  if (product?.variants?.length > 0) {
    firstVariant = product?.variants[0];
  }

  if (!product?.selling_plan_groups?.length) {
    return null;
  }

  const subsription_usp_content = settings?.subscription_usp_content;
  const subscription_usp_bullet_icon = settings?.subscription_usp_bullet_icon;
  const onetime_usp_content = settings?.onetime_usp_content;
  const onetime_usp_bullet_icon = settings?.onetime_usp_bullet_icon;

  const [activeTab, setActiveTab] = useState( isInTile ? 'subscribe' : 'onetime' );
  const [currentProduct, setCurrentProduct] = useState(product);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOneTimeOption, setSelectedOneTimeOption] = useState(product.id);

  function handleOneTimeOptionClick({ product, prices }) {
    setSelectedOneTimeOption(product.id);
    setCurrentProduct(product);

    const formVariantFields: any = document.querySelectorAll('.add-to-cart-block .form-variant-id');

    if (formVariantFields.length) {
      Array.from(formVariantFields).forEach(
        (formInput: any) => (formInput.value = product.selected_or_first_available_variant_id)
      );
    }

    dispatchEvent(
      new CustomEvent('selling_plan_selected', {
        detail: { product, prices }
      })
    );
     if (isInTile) return;
     if (currentProduct.handle !== product.handle) {
       window.location.href = `/products/${product.handle}`;
    }
}

  useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');

  if (tabParam === 'subscribe') {
    setActiveTab('subscribe');
  }
}, []);

  const disableAtcButtons = (isDisabled) => {
    const atcButtons = document.querySelectorAll('.add-to-cart-submit-button');
    atcButtons.forEach((button) => {
      if (button instanceof HTMLButtonElement) {
        button.disabled = isDisabled;
      }
    });
  }

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    disableAtcButtons(tab === 'subscribe');

    const formSellingPlanFields = document.querySelectorAll(
      '.add-to-cart-block .form-selling-plan-id'
    ) as NodeListOf<HTMLInputElement>;

    formSellingPlanFields.forEach((formInput) => {
      formInput.value = '';
    });
  }

  const renderInlineLayout = () => (
    <div className='product-selling-groups__inline'>
      {product.selling_plan_groups?.map((sellingPlanGroup, groupIndex) =>
        sellingPlanGroup.selling_plans?.slice(0, limit).map((sellingPlan, planIndex) => {
          // Extract the selling plan price adjustment value
          const priceAdjustment = sellingPlan.price_adjustments[0];
          let sellingPlanPrice: any = 0;

          if (priceAdjustment.value_type === 'percentage') {
            sellingPlanPrice = ((product.price * (1 - priceAdjustment.value / 100)) / 100).toFixed(2);
          } else if (priceAdjustment.value_type === 'fixed') {
            sellingPlanPrice = ((product.price - priceAdjustment.adjustmentValue.price.amount) / 100).toFixed(2);
          }

          return (
            <React.Fragment key={planIndex}>
              <div
                className='product-selling-groups__option'
                key={sellingPlan.id}
              >
                <input
                  type='radio'
                  name='subscription'
                  value={sellingPlan.id}
                  id={`plan-${sellingPlan.id}`}
                  className='product-selling-groups__radio'
                  x-on:click='sellingGroupSelected'
                  data-sellinggroup-price={sellingPlanPrice}
                  data-variant-id={firstVariant?.id}
                  defaultChecked={
                    (!isInTile && groupIndex === 0 && planIndex === 0) ||
                    (isInTile && groupIndex === 0 && planIndex === 0)
                  }
                  // checked={(!isInTile && groupIndex === 0 || planIndex === 0) && true}
                />

                <div className='product-selling-groups__details flex max-lg:flex-col gap-2 lg:items-center lg:justify-between w-full'>
                  <label
                    htmlFor={`plan-${sellingPlan.id}`}
                    className='product-selling-groups__label b2'
                  >
                    <span>{sellingPlan.name}</span>

                    {!isInTile && (
                      <div className='flex'>
                        {priceAdjustment.value_type === 'percentage' && (
                          <span className='product-selling-groups__badge'>SAVE {priceAdjustment.value}%</span>
                        )}
                        {priceAdjustment.value_type === 'fixed' && (
                          <span className='product-selling-groups__badge'>
                            {((product.price - priceAdjustment.adjustmentValue.price.amount) / product.price) * 100}%
                          </span>
                        )}
                      </div>
                    )}
                  </label>

                  <div className='product-selling-groups__price'>
                    {isInTile && (
                      <div className='is-in-tile max-lg:ml-2 flex'>
                        {priceAdjustment.value_type === 'percentage' && (
                          <span className='product-selling-groups__badge'>SAVE {priceAdjustment.value}%</span>
                        )}
                        {priceAdjustment.value_type === 'fixed' && (
                          <span className='product-selling-groups__badge'>
                            {((product.price - priceAdjustment.adjustmentValue.price.amount) / product.price) * 100}%
                          </span>
                        )}
                      </div>
                    )}

                    <div className='product-selling-groups__final-price b3__regular'>
                      <span>
                        ${sellingPlanPrice}
                        <span className='product-selling-groups__monthly'>/{isInTile ? 'mth' : 'month'}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {isInTile && (
                <div className='product-selling-groups__onetime-option'>
                  <div className='product-selling-groups__option'>
                    <input
                      type='radio'
                      name='subscription'
                      x-on:click='sellingGroupSelected'
                      data-sellinggroup-price={product.price / 100}
                      data-variant-id={firstVariant?.id}
                      className='product-selling-groups__radio form-radio'
                      defaultChecked={isInTile && true}
                      // checked={isInTile && true}
                    />
                    <label
                      htmlFor='subscription'
                      className='product-selling-groups__label b2'
                    >
                      Buy Once
                    </label>
                    <span className='product-selling-groups__price b3__regular'>${productPrice.toFixed(2)}</span>
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })
      )}
    </div>
  );

  const renderTabsLayout = () => (
    <div>
      
      { !isInTile  &&
      <div className='product-selling-groups__tab-list'>
        <div
          className={`product-selling-groups__tab one-time h6 ${
            activeTab === 'onetime' ? 'product-selling-groups__tab--active' : ''
          }`}
          onClick={() => handleTabClick('onetime')}
        >
          <div className='product-selling-groups__tab-radio'></div>
          <span>{settings?.one_time}</span>
        </div>

        <div
          className={`product-selling-groups__tab subscription h6 ${
            activeTab === 'subscribe' ? 'product-selling-groups__tab--active' : ''
          }`}
          onClick={() => handleTabClick('subscribe')}
        >
          <span className='product-selling-groups__tab-radio'></span>
          <span>{settings?.subscription}</span>
        </div>
      </div>
    }
    

      <div className='product-selling-groups__content'>
        {activeTab === 'subscribe' && (
          <div className='product-selling-groups__options'>
            <SubscriptionTab
              currentProduct={currentProduct}
              bundle={bundle}
              settings={settings}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              onProductSelect={(productData) => handleOneTimeOptionClick(productData)}
              onSubscriptionSelect={(value) => disableAtcButtons(value === 0)}
              isInTile={isInTile}
              usp_content={subsription_usp_content}
              usp_bullet_icon={subscription_usp_bullet_icon}
            />
          </div>
        )}

        {activeTab === 'onetime' && (
          <div className='product-selling-groups__onetime-option'>
            {bundle.products.map((product, index) => (
              <ProductBundleItem
                key={product.id}
                index={index}
                product={product}
                currentProduct={currentProduct}
                bundle={bundle}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                selectedOption={selectedOneTimeOption}
                onClick={(productData) => handleOneTimeOptionClick(productData)}
                type='one-time'
                translations={translations} // Pass translations here
             
              />
            ))}
            { onetime_usp_content  && (
              <div className={clsx('product-selling-groups__usp-content', {
                      'custom-icon': onetime_usp_bullet_icon !== '',
                      'one-column': bundle.products.length % 2 === 0
                    })}>
                <Paragraph
                  text={onetime_usp_content ? addIconsToListItems(onetime_usp_content, onetime_usp_bullet_icon) : ''}
                  type={'b4'}
                  classes="rich-content"
                />
              </div>
                  
            )}
          </div>
        )}
      </div>
    </div>
  );

  const LayoutComponent: any = 'ajax-cart-product-form';

  return (
    <div
      x-data='sellinggroups'
      className='product-selling-groups'
    >
      {layout === 'inline' ? renderInlineLayout() : renderTabsLayout()}

      {showAddToCart && (
        <div className='product-selling-groups__add-to-cart'>
          <LayoutComponent class='product-selling-groups__form'>
            <form
              action='/cart/add'
              id='product_form_id'
              className='product-selling-groups__form-inner product-form'
              noValidate
              data-prodify-product-form
            >
              <input
                type='hidden'
                name='id'
                value={product.variants[0]?.id}
              />
              <button
                name='add'
                className='product-selling-groups__button button button-tertiary'
              >
                <span className='b2 atc-label'>Add to Cart | ${productPrice.toFixed(2)}</span>
              </button>
            </form>
          </LayoutComponent>
        </div>
      )}
    </div>
  );
};
